import { HOME_PLACEHOLDER_DASHBOARD } from 'business/constants';
import { useSelector } from 'store/hooks';

export const useGetConvertedSlug = (
    dashboardSlug: string | null | undefined,
) => {
    const { isAuthenticated, user } = useSelector((state) => state.vision);
    return dashboardSlug === HOME_PLACEHOLDER_DASHBOARD && isAuthenticated
        ? user && parseInt(user.homeDashboardSlug, 10)
        : dashboardSlug;
};
